<template>
	<div class="options-wrapper">
		<div class="options-wrapper-compact" :open="open">
			<div class="margin-tp-5">
				<Icon
					v-if="!open"
					name="i-hamburger"
					type="filled"
					size="medium"
					state="dark"
					class="margin-lt-6"
					@click="toggleOptions()"
				/>
			</div>
			<Icon
				v-if="open"
				name="i-hamburger-close"
				:effects="false"
				size="medium"
				state="dark"
				type="filled"
				class="margin-tp-6 margin-lt-6"
				@click="toggleOptions()"
			/>
		</div>
		<div class="options-wrapper-backout" :open="open" @click="toggleOptions()" />
		<div class="flow-options" :open="open">
			<slot />
			<div v-if="$slots['footer']" class="options-wrapper-footer">
				<slot name="footer" />
			</div>
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../../Icon/Icon";
/**
 * Options Wrapper holds the options like vertical menus. When there are multiple columns in a slide-out, content that user sees in the leftmost column like vertical menus is usually wrapped in “Options Wrapper”. Content of “Content Wrapper” changes based on user’s interaction with options in options wrapper.
 */
export default defineComponent({
	name: "OptionsWrapper",
	components: {
		Icon
	},
	data() {
		return {
			open: false
		};
	},
	methods: {
		toggleOptions() {
			this.open = !this.open;
		}
	}
});
</script>
<style lang="scss">
$border-color: var(--slideout-border-light);
$compact-width: 61px;

div.options-wrapper {
	height: 100%;
	overflow-y: auto;
	border-right: 1px solid $border-color;
	width: 288px;
	min-width: $compact-width;

	> div.options-wrapper-compact {
		width: $compact-width;
		display: none;
	}
	> div.flow-options {
		// height: 100%;
		display: flex;
		flex-direction: column;

		> div.options-wrapper-footer {
			margin-top: auto;
		}
	}

	div.slab-hierarchy
		> div.slab-container
		> div.slab-content
		> div.slab-title
		> span.slab-title-wrapper {
		h1 {
			line-height: 20px;
		}

		h2 {
			line-height: 18px;
		}

		h3 {
			line-height: 16px;
		}
		h4 {
			line-height: 14px;
		}

		h5 {
			line-height: 12px;
		}

		h6 {
			line-height: 10px;
		}
		.paragraph-1 {
			line-height: 14px;
		}

		.paragraph-2 {
			line-height: 12px;
		}
		.paragraph-3 {
			line-height: 10px;
		}
		.paragraph-4 {
			line-height: 8px;
		}
	}
}

@media (max-width: 700px) {
	div.options-wrapper {
		width: $compact-width;
		> div.options-wrapper-compact {
			display: flex;
			justify-content: flex-start;
			padding: 12px;
			position: absolute;
			background-color: var(--slideout-background);
			left: 0px;
			top: 0px;
			bottom: 0px;
			width: $compact-width;
			border-right: 1px solid $border-color;
			transition: width 0.3s linear;
			z-index: 5;
			&[open] {
				width: 240px;
				// transform: translateX(0%);
			}
		}
		> div.options-wrapper-backout[open] {
			position: absolute;
			background-color: var(--slideout-blackout);
			left: 0px;
			top: 0px;
			bottom: 0px;
			right: 0px;
			z-index: 3;
			transition: background-color 0.3s linear;
		}
		> div.flow-options {
			transition: width 0.3s linear;
			// transform: translateX(-200%);

			position: absolute;
			left: 0px;
			top: 60px;
			bottom: 0px;
			width: $compact-width;
			background-color: var(--slideout-background);
			border-right: 1px solid $border-color;
			border-top: 1px solid $border-color;

			z-index: 5;

			&[open] {
				width: 240px;
				// transform: translateX(0%);
			}
			div.slab-hierarchy > div.slab-container > div.slab-content > div.slab-primary-action {
				padding-left: 12px;
			}
		}
	}
}
@media (min-width: 768px) {
	div.options-wrapper {
		width: 240px;
	}
}
@media (min-width: 992px) {
	div.options-wrapper {
		width: 288px;
	}
}

@media (min-width: 1200px) {
	div.options-wrapper {
		width: 320px;
	}
}
</style>
